export default __webpack_public_path__ + "static/char-v-43-zh-Hant-c9c5e1150fead8a473e3592eae430da1.mp4";